import { Observable } from 'rxjs';

export const observeOnResize = (target: HTMLElement): Observable<ResizeObserverEntry[]> =>
  new Observable(observer => {
    const resizeObserver = new ResizeObserver(entries => {
      observer.next(entries);
    });
    resizeObserver.observe(target);
  });
